import { Box } from '@mui/material'
import { Novedad } from '../../../../types/responses-novedades'
import { memo, useState } from 'react'
import NovedadHeader from './NovedadHeader'
import NovedadBody from './NovedadBody'
import { NovedadControl, NovedadControlEnum } from './novedad-types'

interface Props {
  novedad: Novedad
}

const SingleNovedad = ({ novedad }: Props) => {
  const { productoInterno: productoAA1T, productoExterno: productoTienda } = novedad
  const [control, setControl] = useState<NovedadControl>({
    nombre: NovedadControlEnum.IDLE,
    descripcion: NovedadControlEnum.IDLE,
    precio: NovedadControlEnum.IDLE,
    fotos: NovedadControlEnum.IDLE
  })

  return (
    <Box p={{ xs: '0px', md: '24px' }}>
      <NovedadHeader producto={productoAA1T} setControl={setControl} />
      <NovedadBody novedad={novedad} control={control} setControl={setControl} />
    </Box>
  )
}

export default memo(SingleNovedad)
